import DateFiltersProvider from "../../../components/shared/filters/DateFilters/context";
import Content from "./Content";
import { DateFiltersMode } from "../../../components/shared/filters/DateFilters/types";

const modes: DateFiltersMode[] = ["day", "week", "month", "custom"];

function OpenShifts() {
    return (
        <DateFiltersProvider modes={modes} mode="week">
            <Content />
        </DateFiltersProvider>
    );
}

export default OpenShifts;
